module.exports = __webpack_public_path__ + "img/office-icon-active.72e1ecd9.svg";